import type { DemoScript } from '../../../types/demo';
import { callCenterScript } from './callCenter';
import { documentIntelScript } from './documentIntel';
import { dataAnalyticsScript } from './dataAnalytics';
import { videoIntelScript } from './videoIntel';
import { researchScript } from './research';
import { apiPipelineScript } from './apiPipeline';
import { sheetsIndiaScript } from './sheetsIndia';
import { uploadIngestScript } from './uploadIngest';

/** Registry of all available demo scripts, keyed by script ID */
const scriptRegistry: Record<string, DemoScript> = {
  'call-center': callCenterScript,
  'document-intel': documentIntelScript,
  'data-analytics': dataAnalyticsScript,
  'video-intel': videoIntelScript,
  'research': researchScript,
  'api-pipeline': apiPipelineScript,
  'sheets-india': sheetsIndiaScript,
  'upload-ingest': uploadIngestScript,
};

/** Get a demo script by ID. Returns null if not found. */
export function getDemoScript(scriptId: string): DemoScript | null {
  return scriptRegistry[scriptId] ?? null;
}

/** Get all available demo script IDs */
export function getAvailableScriptIds(): string[] {
  return Object.keys(scriptRegistry);
}

/** Check if a demo script exists for a given template ID */
export function hasScriptForTemplate(templateId: string): boolean {
  return Object.values(scriptRegistry).some((s) => s.templateId === templateId);
}

/** Get the script ID for a given template ID */
export function getScriptIdForTemplate(templateId: string): string | null {
  const script = Object.values(scriptRegistry).find((s) => s.templateId === templateId);
  return script?.id ?? null;
}
